import AbstractProductType from './AbstractProductType'
import { ProductTypeFormat } from './types'

export default class SelfRooftopOversized extends AbstractProductType {

  name = 'self_rooftop_oversized'
  title = 'Self Rooftop Oversized'

  oversized = true
  format = ProductTypeFormat.Rooftop

}
